import UnleashFlagProvider from '@unleash/proxy-client-react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { useState } from 'react'
import { I18nextProvider } from 'react-i18next'

import { configureCognito } from '../configs/cognito'
import { unleashClient } from './clients/unleash-client'
import { CognitoAuthProvider } from './contexts/cognitoAuthContext'
import { useOnce } from './hooks/useOnce'
import { AntdLocaleProvider } from './locales/AntdLocaleProvider'
import i18n from './locales/i18n'
import { PersistQueryClientProvider } from './queries/QueryClientProvider'
import { AppRoutes } from './routes'

configureCognito()

function App() {
  const [unleashIsReady, setUnleashIsReady] = useState(false)
  useOnce(() => {
    const maybeMockApi = async () => {
      if (process.env.NODE_ENV !== 'production') {
        await import('./services/mockApi/polly').then(({ startMockServer }) => startMockServer())
      }
      await unleashClient.start()
      setUnleashIsReady(true)
    }
    void maybeMockApi()
  })

  return (
    <UnleashFlagProvider unleashClient={unleashClient} startClient={false}>
      <I18nextProvider i18n={i18n}>
        <AntdLocaleProvider language={i18n.language}>
          <PersistQueryClientProvider>
            <NuqsAdapter>
              <CognitoAuthProvider>
                <AppRoutes providersAreReady={unleashIsReady} />
              </CognitoAuthProvider>
            </NuqsAdapter>
          </PersistQueryClientProvider>
        </AntdLocaleProvider>
      </I18nextProvider>
    </UnleashFlagProvider>
  )
}

export default App
